import { render, staticRenderFns } from "./4.vue?vue&type=template&id=645a1761&scoped=true"
import script from "./4.vue?vue&type=script&lang=js"
export * from "./4.vue?vue&type=script&lang=js"
import style0 from "./4.vue?vue&type=style&index=0&id=645a1761&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645a1761",
  null
  
)

export default component.exports